import React from 'react';
import PubSub from "services/PubSub";
import style from './style.scss'; //NOSONAR


const PaymentFail = () => {

    const _close = () => {
        setTimeout(() => PubSub.dispatch('failed_payment_close'), 0);
    }

    return (
        <div className={'new-modal-container'}>
            <div className={'new-modal-scroll'}>
                <h1 className="new-modal-title">Error de conexión</h1>
                <span className="payment-fail-info">Lo sentimos, ha ocurrido un error interno. Por favor vuelve a intentarlo.</span>
            </div>
            <div className="modal-actions">
                <button type="button" className="primary-btn" onClick={_close}>Aceptar</button>
            </div>
        </div>

    )

}

export default PaymentFail;
